import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export function ThemeToggle({ variant = 'default' }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  if (variant === 'mobile') {
    return (
      <button
        onClick={toggleTheme}
        className="flex items-center gap-3 px-4 py-3.5 rounded-xl text-theme-text hover:bg-theme-hover w-full font-medium transition-colors"
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        {isDark ? (
          <>
            <Sun className="h-5 w-5 text-theme-primary" />
            <span>Light Mode</span>
          </>
        ) : (
          <>
            <Moon className="h-5 w-5 text-theme-primary" />
            <span>Dark Mode</span>
          </>
        )}
      </button>
    );
  }

  // Default header variant — use a plain <button> rather than the shadcn
  // <Button variant="ghost"> because the ghost variant applies
  // `hover:bg-accent hover:text-accent-foreground`. In light mode that
  // paints the icon white on hover (accent-foreground = white); in dark
  // mode it would paint the icon dark. Plain button + explicit hover
  // classes give us full control of the hover colour per theme.
  return (
    <button
      onClick={toggleTheme}
      className={`inline-flex items-center justify-center h-9 w-9 rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#002FA7]/40 ${
        isDark
          ? 'text-white hover:text-white hover:bg-white/10'
          : 'text-theme-text-secondary hover:text-theme-text hover:bg-theme-hover'
      }`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      data-testid="theme-toggle"
    >
      {isDark ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
    </button>
  );
}
